import _ from 'lodash'

const tzdata = [
  { 'value': 1, 'offset': 720, 'name': 'Etc/GMT+12' },
  { 'value': 2, 'offset': 660, 'name': 'Pacific/Niue' },
  { 'value': 3, 'offset': 600, 'name': 'US/Hawaii' },
  { 'value': 4, 'offset': 570, 'name': 'Pacific/Marquesas' },
  { 'value': 5, 'offset': 540, 'name': 'US/Alaska' },
  { 'value': 6, 'offset': 480, 'name': 'Pacific/Pitcairn' },
  { 'value': 7, 'offset': 420, 'name': 'Canada/Pacific' },
  { 'value': 8, 'offset': 360, 'name': 'Canada/Saskatchewan' },
  { 'value': 9, 'offset': 300, 'name': 'Pacific/Easter' },
  { 'value': 10, 'offset': 270, 'name': 'America/Aruba' },
  { 'value': 11, 'offset': 240, 'name': 'America/Aruba' },
  { 'value': 12, 'offset': 210, 'name': 'Canada/Newfoundland' },
  { 'value': 13, 'offset': 180, 'name': 'America/Sao_Paulo' },
  { 'value': 14, 'offset': 150, 'name': 'America/St_Johns' },
  { 'value': 15, 'offset': 120, 'name': 'America/Noronha' },
  { 'value': 16, 'offset': 60, 'name': 'Atlantic/Cape_Verde' },
  { 'value': 17, 'offset': 0, 'name': 'Universal' },
  { 'value': 18, 'offset': -60, 'name': 'Europe/Berlin' },
  { 'value': 19, 'offset': -120, 'name': 'Africa/Cairo' },
  { 'value': 20, 'offset': -180, 'name': 'Asia/Istanbul' },
  { 'value': 21, 'offset': -210, 'name': 'Asia/Tehran' },
  { 'value': 22, 'offset': -240, 'name': 'Asia/Dubai' },
  { 'value': 23, 'offset': -270, 'name': 'Asia/Kabul' },
  { 'value': 24, 'offset': -300, 'name': 'Asia/Karachi' },
  { 'value': 25, 'offset': -330, 'name': 'Asia/Kolkata' },
  { 'value': 26, 'offset': -345, 'name': 'Asia/Kathmandu' },
  { 'value': 27, 'offset': -360, 'name': 'Asia/Dhaka' },
  { 'value': 28, 'offset': -390, 'name': 'Asia/Yangon' },
  { 'value': 29, 'offset': -420, 'name': 'Asia/Jakarta' },
  { 'value': 30, 'offset': -480, 'name': 'Asia/Hong_Kong' },
  { 'value': 31, 'offset': -525, 'name': 'Australia/Eucla' },
  { 'value': 32, 'offset': -540, 'name': 'Asia/Seoul' },
  { 'value': 33, 'offset': -570, 'name': 'Australia/Darwin' },
  { 'value': 34, 'offset': -600, 'name': 'Australia/Brisbane' },
  { 'value': 35, 'offset': -630, 'name': 'Australia/Adelaide' },
  { 'value': 36, 'offset': -660, 'name': 'Australia/Sydney' },
  { 'value': 37, 'offset': -690, 'name': 'NZ' },
  { 'value': 38, 'offset': -720, 'name': 'Asia/Anadyr' },
  { 'value': 39, 'offset': -765, 'name': 'Pacific/Chatham' },
  { 'value': 40, 'offset': -780, 'name': 'Pacific/Fakaofo' },
  { 'value': 41, 'offset': -825, 'name': 'Pacific/Chatham' },
  { 'value': 42, 'offset': -840, 'name': 'Pacific/Kiritimati' }
]

const TimezoneConverter = (key, value) => {
  let tz = _.find(tzdata, v => v[key] === value)
  tz.offset = tz.offset * -1
  return tz
}

const getExt = (osId) => {
  switch (osId) {
    case 3: return 'png'
    case 4: return 'png'
    default: return 'jpg'
  }
}
export default getExt

export { TimezoneConverter, getExt }
